import { useCallback } from 'react';

const globalCellRefs = { current: {} };

export const useCellRefs = () => {
  const setCellRef = useCallback((element, cellId) => {
    if (element) {
      globalCellRefs.current[cellId] = element;
    }
  }, []);

  return { cellRefs: globalCellRefs, setCellRef };
};
